var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "tc"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [(!_vm.addtc) ? _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true",
      "title": "Search Filter"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Add New TC"
    },
    on: {
      "click": _vm.showAddForm
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square-o fa-2x",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "style": "color: red"
    }
  })])])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Terms and Condition Template Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-info-circle'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.templateName),
      expression: "templateName"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('TemplateName')
    },
    attrs: {
      "id": "templateName",
      "name": "templateName",
      "type": "text",
      "placeholder": "Enter Template Name"
    },
    domProps: {
      "value": (_vm.templateName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.templateName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('templateName')),
      expression: "errors.has('templateName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('templateName')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-gear' style='font-size: 12px'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.statuslist,
      "selected-option": _vm.statusitem,
      "placeholder": "Select Status",
      "name": "Status"
    },
    on: {
      "select": _vm.selectedStatus
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.serachFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("   \n                      "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetSearchfilter
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])], 1)])])])], 1)], 1)]), _vm._v(" "), _c('fieldset', [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Terms And Conditions List")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('b', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Total Records: " + _vm._s(_vm.totalCount))])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('custom-expandable-table', {
    attrs: {
      "columns": _vm.tableColumn,
      "items": _vm.tableItems,
      "innerTableHeader": _vm.innerTableColumn,
      "offset": _vm.offset
    },
    on: {
      "customTableEvent": _vm.getCustomTableEvent
    }
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "active": _vm.isViewLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isViewLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.expanded == false) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Expand All"
    },
    on: {
      "click": _vm.expandAll
    }
  }, [_vm._v("\n                      Expand All "), _c('i', {
    staticClass: "fa fa-plus-circle"
  })]) : _vm._e(), _vm._v(" "), (_vm.expanded == true) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Collapse All"
    },
    on: {
      "click": _vm.collapseAll
    }
  }, [_vm._v("\n                      Collapse All "), _c('i', {
    staticClass: "fa fa-minus-circle"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[1]),
      expression: "accordianTab[1]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "clientcontracttc",
      "id": "chck1"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[1]) ? _vm._i(_vm.accordianTab[1], null) > -1 : (_vm.accordianTab[1])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(1)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck1"
    }
  }, [_vm._v("Billing Terms")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_c('strong', [_vm._v("Billing Cycle : ")])]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.billingCycle))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_c('strong', [_vm._v("POD Hard Copy required : ")])]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.pod))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(this.billingCycle == "Monthly" || this.billingCycle == "Fortnightly") ? _c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_c('strong', [_vm._v("Last Date for Bill Submission : ")])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Cycle")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Day of the Month(1-31)")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.date1))])]), _vm._v(" "), (_vm.billingCycle == 'Fortnightly') ? _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.date2))])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.pod == 'Yes') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_c('strong', [_vm._v("POD Hard Copy Charges (INR per POD) : ")])]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.podCharge))])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[2]),
      expression: "accordianTab[2]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "clientcontracttc",
      "id": "chck2"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[2]) ? _vm._i(_vm.accordianTab[2], null) > -1 : (_vm.accordianTab[2])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(2)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[2] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[2] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 2, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck2"
    }
  }, [_vm._v("Credit and Payment Terms")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_c('strong', [_vm._v("Credit Period (Days) : ")]), _vm._v(_vm._s(_vm.creditPeriod)), _c('br'), _vm._v("(From Date of Submission of Bill): ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_c('strong', [_vm._v("Credit Limit (INR) : ")])]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.creditLimit))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_c('strong', [_vm._v("Advance Payment % : ")])]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.advancePayment))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_c('strong', [_vm._v("Credit Limit Alert % :")])]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.creditAlert))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("(For FTL Mode Only)")])]), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "form-group row checkbox"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_c('strong', [_vm._v("Payment Mode : ")])]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.paymentmode))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("In favour of "), _c('b', [_vm._v("Busybees Logistics Solutions Pvt. Ltd")])])]), _c('br')])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[3]),
      expression: "accordianTab[3]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "clientcontracttc",
      "id": "chck3"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[3]) ? _vm._i(_vm.accordianTab[3], null) > -1 : (_vm.accordianTab[3])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(3)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[3] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[3] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 3, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck3"
    }
  }, [_vm._v("Other Terms and Conditions")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_c('strong', [_vm._v("Max Liability")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_c('strong', [_vm._v("Max Liability Amount (INR) : ")])]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.liabilityAmount))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v("COF to be issued for lost,damaged or pilferage in case liability is more than maximum liability amount")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_c('strong', [_vm._v("COF (Certificate of Fact)")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v("Shipment will be accepted for transportation on the owner's risk basis. The shipper\n                              is required to make his own transit insurance . In the event of any unforeseen circumstances or damage or loss\n                              ,the certificate of fact (COF) will be issued by XpressBees .")])])])])])])])], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalCount,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.addtc) ? _c('div', [_c('div', [_c('Create-Term-Condition', {
    attrs: {
      "selectedEditRowData": _vm.selectedEditRow
    },
    on: {
      "goBackToParent": _vm.eventFromParent
    }
  })], 1)]) : _vm._e()], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b00e6e2","hasScoped":true}!./src/modules/masterdata/views/tc/listingtc/listingtc.component.html
// module id = 780
// module chunks = 3